import { Box, CheckCircle, Text } from '@factorialco/deprecated-design-system'
import {
  BreakConfigurationFragment,
  TimePlanningPlannedBreakBreakTypeEnum as BreakType,
} from 'generated/resources/graphql'

import TimePicker from 'modules/core/components/Inputs/TimePicker'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { TIME_REGEX } from 'modules/core/lib/formatTime'

import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'
import { DayConfigurationWithBreaksForm } from 'modules/work_schedules/hooks/useDayConfigurations'

import AddFieldButton from './AddFieldButton'
import WorkScheduleBreakInputs from './WorkScheduleBreakInputs'

interface Props {
  dayConfigForm: DayConfigurationWithBreaksForm
  dayName: string
  onAddBreak: (
    breakConfiguration: BreakConfigurationFragment,
    breakType: BreakType,
    dayConfiguration: DayConfigurationWithBreaksForm
  ) => void
  onDeleteBreak: (dayConfiguration: DayConfigurationWithBreaksForm, form: PlannedBreakForm) => void
  canAddBreaks: boolean
}

const FlexibleDayConfigurationInput = ({
  dayConfigForm,
  dayName,
  onAddBreak,
  onDeleteBreak,
  canAddBreaks,
}: Props) => {
  const time = dayConfigForm.dayConfiguration.get('duration_in_hours')

  const noTime = '00:00'
  const isValid = time.value !== noTime && time.value.match(TIME_REGEX)

  const onAddBreakToDayConfig = (
    breakConfiguration: BreakConfigurationFragment,
    breakType: BreakType
  ) => {
    onAddBreak(breakConfiguration, breakType, dayConfigForm)
  }

  const {
    access: { timeFormat },
  } = useCurrentSession()

  return (
    <Box
      aria-label={dayName}
      border={{
        all: {
          color: 'grey400',
          width: 's2',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      background="grey000White"
      flexDirection="column"
      padding="s16"
      gap="s16"
    >
      <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
        <Box flexDirection="row" gap="s8">
          <Box width="s24">
            <CheckCircle checked={!!isValid} disabled={false} />
          </Box>
          <Text.Normal weight="medium">{dayName}</Text.Normal>
        </Box>

        <Box flexDirection="row" gap="s16" width="s300" justifyContent="spaceBetween">
          <TimePicker field={time} />

          {canAddBreaks && <AddFieldButton onAddBreak={onAddBreakToDayConfig} />}
        </Box>
      </Box>

      {!!dayConfigForm.breaks.length && (
        <Box flexDirection="column" gap="s8">
          {dayConfigForm.breaks.map((form, i) => (
            <WorkScheduleBreakInputs
              key={i}
              form={dayConfigForm}
              breakForm={form}
              validationParams={{
                duration: dayConfigForm.dayConfiguration.duration(timeFormat ?? 24),
              }}
              onDeleteBreak={onDeleteBreak}
            />
          ))}
        </Box>
      )}
    </Box>
  )
}

export default FlexibleDayConfigurationInput
